import { Box, Button, Typography } from "@mui/material";
import { useRouter } from "@tanstack/react-router";
import { type FC, useCallback } from "react";
import { useTranslation } from "react-i18next";

export const Page404: FC = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const handleBack = useCallback(() => router.history.back(), [router]);

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexGrow: 1,
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          borderRadius: "2em",
          display: "grid",
          flexGrow: 1,
          gap: 1,
          // gridTemplateColumns: "repeat(3, 1fr)",
          gridAutoColumns: "1fr",
          gridTemplateAreas: `
            "header header header"
            "subheader subheader subheader"
            "main main main"
            ". go_back ."
          `,
          gridTemplateRows: "auto",
          height: 300,
          justifyContent: "center",
          maxWidth: 800,
          minHeight: "50vh",
          p: 3,
        }}
      >
        <Typography
          sx={{
            gridArea: "header",
            textAlign: "center",
            textTransform: "uppercase",
          }}
          variant="h1"
        >
          404
        </Typography>

        <Typography
          sx={{
            gridArea: "subheader",
            textAlign: "center",
            textTransform: "uppercase",
          }}
          variant="h4"
        >
          {t("errors.notFound.title")}
        </Typography>

        <Typography style={{ gridArea: "main", textAlign: "center" }}>
          {t("errors.notFound.explanation")}
        </Typography>

        <Button
          onClick={handleBack}
          size="large"
          sx={{
            gridArea: "go_back",
            justifyContent: "space-around",
            width: "100%",
          }}
          variant="contained"
        >
          {t("common.back")}
        </Button>
      </Box>
    </Box>
  );
};
